import { render, staticRenderFns } from "./ActivitiesCard.vue?vue&type=template&id=6150bdaa&scoped=true"
import script from "./ActivitiesCard.vue?vue&type=script&lang=js"
export * from "./ActivitiesCard.vue?vue&type=script&lang=js"
import style0 from "./ActivitiesCard.vue?vue&type=style&index=0&id=6150bdaa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6150bdaa",
  null
  
)

export default component.exports